import { Component, OnInit } from '@angular/core';
import { PackagingUnitExpenseResultsDto } from 'src/app/data-transfer/entities/evaluation-entities/expense-result-dto';
import { PackagingUnitDto } from 'src/app/data-transfer/entities/packaging-unit-entities/packaging-unit-dto';
import { ExpenseCalculationParentComponent } from '../expense-calculation-parent/expense-calculation-parent.component';
import { ActivatedRoute } from '@angular/router';
import { PackagingPart } from 'src/app/model/packaging-part-enum';
import { DisplayType } from '../expense-calculation-html-template/expense-calculation-html-template.component';
import { AuthService } from 'src/app/services/auth-service';

@Component({
  selector: 'app-expense-calculation-packaging-unit',
  templateUrl: './expense-calculation-packaging-unit.component.html',
  styleUrls: ['./expense-calculation-packaging-unit.component.scss']
})
export class ExpenseCalculationPackagingUnitComponent extends ExpenseCalculationParentComponent implements OnInit {
  selectedExpenseResults!: PackagingUnitExpenseResultsDto[];
  expenseResults!: PackagingUnitExpenseResultsDto[][];
  packagingUnit!: PackagingUnitDto;
  isUserValidator = false;

  DisplayType = DisplayType;

  constructor(private route: ActivatedRoute,
              private authService: AuthService) {
    super();
    this.isUserValidator = this.authService.isUserValidator();
  }

  ngOnInit(): void {
    this.routeDataSubscription = this.route.data.subscribe(data => {
      const packagingUnit = data.packagingUnit;
      this.expenseResults = data.expenseResults;
      this.selectedExpenseResults = data.expenseResults[0];
      this.packagingUnit = packagingUnit;
      this.packagingPartType = PackagingPart.Unit;
      this.licenseFeeCountries = data.licenseFeeCountries;
      this.ecomodulationCountries = data.ecomodulationCountries;
      this.plasticTaxCountries = data.plasticTaxCountries;

      this.routeParamsSubscription = this.route.params.subscribe(params => {
        const licenseFeeResultId = params.licenseFeeId;
        const ecomodulationResultId = params.ecomodulationId;
        const plasticTaxResultId = params.plasticTaxId;

        const expenseResults = this.expenseResults.find(x => x[0].licenseFee?.id === licenseFeeResultId ||
                                                        x[0].plasticTax?.id === plasticTaxResultId ||
                                                        x[0].ecomodulation?.id === ecomodulationResultId);

        if (expenseResults) {
          this.selectedExpenseResults = expenseResults;
        }
      });
    });
  }
}
